import { checkRole, findServiceArea, getAddressDetails, nonZeroCoordinateValidator, spaceTypeList } from './../../../utils/utils.common';
import { Component, OnInit, Input, Output, EventEmitter, ElementRef, OnChanges, SimpleChanges, OnDestroy, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormArray, FormControl, AbstractControl } from '@angular/forms';
import { Observable, Subject, forkJoin } from 'rxjs';
import { sweetAlert } from 'src/app/utils/swal';
import { Router, ActivatedRoute } from '@angular/router';
import { getBrokersList, getstandingOrderDays } from '../../../utils/utils.common';
import * as moment from 'moment-timezone';
import { SocketService } from 'src/app/service/socket-service/socket-service.service';
import { Events } from 'src/app/utils/event-utils';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { AssigTripsService } from '../assigntrips-service/assigntrips-service';
import { DriversService } from '../../drivers/drivers-service/drivers-service';
import { KeyValue } from '@angular/common';
import { debounceTime, distinctUntilChanged, switchMap, takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { ProTipsServiceService } from '../../helping-material/nemt-pro-tips/service/pro-tips-service.service';
import { imageProcessing } from 'src/app/utils/image-processing-utils';
import { ToastrService } from 'ngx-toastr';
import { TripPurposesService } from '../../trip-purposes/service/trip-purposes.service';
import { MemberService } from '../../members/member-service/member.service';
import { CorporateService } from '../../corporate-user/corporate-service/corporate-service';
import { ModifierCodesService } from '../../modifier-codes/modifier-codes-service/modifier-codes.service';
import { LevelOfServiceService } from '../../level-of-service/service/level-of-service.service';
import { PrimaryDiagnosisService } from '../../primary-diagnosis/primary-diagnosis-service/primary-diagnosis.service';
import { EquipmentService } from '../../equipments/equipment-service/equipment.service';
import { ServiceAreasService } from '../../service-areas/service-areas-service/service-areas.service';
import { AssistService } from 'src/app/service/assist-service/assist.service';

@Component({
  selector: 'app-new-trip',
  templateUrl: './new-trip.component.html',
  styleUrls: ['./new-trip.component.css']
})
export class NewTripComponent implements OnInit, OnDestroy {
  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;
  @Input('editId') editId;
  @Input() trip?;
  @Input('isNotAllowToView') isNotAllowToView?;
  @Input() scheduleTime;
  @Input() isStandingOrderClone?;
  @Output() onUpdate = new EventEmitter<string>();
  @Output() onCreate = new EventEmitter<string>();

  newTripForm: UntypedFormGroup;
  addonsServicesForm: UntypedFormGroup;
  timeZone = "America/New_York";
  todayDate = moment().tz(this.timeZone);
  user;
  search = '';
  fundingSourceList = [];
  tripPurposeList = [];
  modifierList = [];
  levelOfServiceList = [];
  spaceTypeList = [];
  spaceTypeMainList = [];
  serviceAreaList = [];
  primaryDiagnoseList = [];
  addonsList = [];
  filteredAddonsList = [];
  driverList = [];
  isAllowRates = false;
  tripId;
  submitted = false;
  addMemberModalObj = null;
  addressPickerObj;
  assistList;
  selectedAssist = [];
  assignedTrips = [];
  googleMilage = null;
  preCooperates = {};
  preLevelOfServices = {};
  preSpaceTypes = {};
  estAppointmentTime: any;
  suggestedPickupTime;
  isCalculating = false;
  isEditDataLoaded = false;
  isPossibility = false;
  possibilityObj;

  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private socketService: SocketService,
    private sharedDataService: SharedDataService,
    private assignTripService: AssigTripsService,
    private equipmentService: EquipmentService,
    private proTipsService: ProTipsServiceService,
    private driverService: DriversService,
    private toastr: ToastrService,
    private tripPurposesService: TripPurposesService,
    private memberService: MemberService,
    private corporateService: CorporateService,
    private modifierCodesService: ModifierCodesService,
    private levelOfServiceService: LevelOfServiceService,
    private primaryDiagnosisService: PrimaryDiagnosisService,
    private serviceArea: ServiceAreasService,
    private assistService: AssistService,
  ) {
  }

  ngOnInit() {

    this.newTripForm = this.fb.group({
      company: ['', Validators.required],

      rawId: [''],
      tripId: [''],
      isMedical: [false], // will remove later
      companyType: [''], // will remove later
      jobType: ['cooperate', Validators.required], // will remove later

      jobDestinationAddress: ['', Validators.required],
      jobDestinationLatitude: [0, [Validators.required, nonZeroCoordinateValidator()]],
      jobDestinationLongitude: [0, [Validators.required, nonZeroCoordinateValidator()]],
      zipCodeDest: [''],

      jobOriginAddress: ['', Validators.required],
      jobOriginLatitude: [0, [Validators.required, nonZeroCoordinateValidator()]],
      jobOriginLongitude: [0, [Validators.required, nonZeroCoordinateValidator()]],
      zipCodeOrg: [''],

      client: ['', Validators.required],
      los: ['', Validators.required],
      losDetails: [{}, Validators.required],
      spaceType: ['', Validators.required],
      spaceTypeDetails: [{}, Validators.required],

      priorityClient: this.fb.group({
        displayName: ['', Validators.required],
        contactNumber: ['0000000000'],
        cellPhone: [''],
        clientId: [''],
        email: [''],
        preDob: ['', this.dobValidator],
        dob: [''],
        weight: [''],
        gender: ['']
      }),

      originAddressAdditional: this.fb.group({
        modifier: [''],
        modifierTwo: [''],
        floor: [''],
        room: [''],
        aptOrSuite: [''],
        place: [''],
        phone: ['']
      }),
      destinationAddressAdditional: this.fb.group({
        modifier: [''],
        modifierTwo: [''],
        floor: [''],
        room: [''],
        aptOrSuite: [''],
        place: [''],
        phone: ['']
      }),

      cooperate: ['', Validators.required],
      cooperateDetails: [{}],

      preScheduleTime: ["", Validators.required],
      preAppointmentTime: ["", Validators.required],
      appointmentTime: ["", Validators.required],
      scheduleTime: ["", Validators.required],
      // preActualAppointmentTime: ["", Validators.required],
      // actualAppointmentTime: ["", Validators.required],
      milage: [null],
      tripLegs: this.fb.array([]),
      addonServices: this.fb.array([]),
      noOfEscorts: [''],
      tripReason: [[]],
      ipa: [''],
      primaryDiagnosis: [''],
      companyNote: [''],
      dispatchNoteTwo: [''],
      attachment: [''],

      preRecurringEndDate: [null],
      recurringEndDate: [''],
      isStandingOrder: [false],
      isRecurring: [false],
      recurringDays: this.fb.array([]),
      isBiWeekly: [false],
      status: [''],
      jobStatus: [''],
      driver: [null],
      events: [[]],
      serviceArea: [''],
      serviceAreaDest: [''],
      // Local Variable
      estimateFare: [{ value: '', disabled: true }],
      isVipTrip: [false],
      preferredDriver: [null],
      isConfirmedTrip: [false],
      isMethadone: [false],
      isDialysis: [false],
      authorizationNumber: [''],
      isWillCall: [false],
      searchMember: [''],
      isEligible: [false],
      isNotEligible: [false]
    });

    if (this.activatedRoute.snapshot.url.length === 3 && this.activatedRoute.snapshot.url[2].path === 'edit') {
      this.tripId = this.activatedRoute.snapshot.url[1].path;
    }

    this.addStandingDays();

    if (this.editId) {
      this.tripId = this.editId;
    }


    this.makeCompulsoryCalls();
    this.formControlsListeners();
  }

  formControlsListeners() {
    this.newTripForm.controls['jobOriginAddress']
      .valueChanges
      .subscribe(value => {
        if (!value) this.suggestedPickupTime = null;
      });

    this.newTripForm.controls['jobDestinationAddress']
      .valueChanges
      .subscribe(value => {
        if (!value) this.suggestedPickupTime = null;
      });

    this.newTripForm.valueChanges
      .subscribe(formValue => {
        const requiredFields = [
          'jobOriginLatitude',
          'jobOriginLongitude',
          'jobDestinationLatitude',
          'jobDestinationLongitude',
          'jobDestinationAddress',
          'jobOriginAddress',
          'cooperate',
          'spaceType',
          'scheduleTime',
          // 'milage',
          'appointmentTime',
          // 'serviceArea'
        ];
        const isValid = requiredFields.every(
          field => {

            return formValue[field] !== null && formValue[field] !== ''
          }
        );
        this.possibilityObj = isValid ? formValue : null;
      });

  }

  setFormFromInputTrip(data) {
    console.log(data);
    const preData = JSON.parse(JSON.stringify(data));

    this.newTripForm.patchValue({
      ...preData,
      preScheduleTime: moment(preData.scheduleTime).tz(this.timeZone),
      preAppointmentTime: moment(preData.appointmentTime).tz(this.timeZone)
    });

    if (data.cooperate) {
      this.getAddonsList(data.cooperate);
    }
  }

  makeCompulsoryCalls() {
    const requests = [
      this.getLevelOfService(),
      this.getSpaceTypeList(),
    ];

    // Make all requests in parallel
    forkJoin(requests).subscribe(
      ([res1, res2]) => {

        if (res1) {
          this.levelOfServiceList = res1;
          this.preLevelOfServices = res1.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
        if (res2) {
          this.spaceTypeMainList = res2;
          this.preSpaceTypes = res2.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }

        this.getTripPurposeList();
        this.getFundingSourceList();
        this.getModifierList();
        this.getPrimaryDiagnoseList();
        // this.getAddonsList();
        this.getAssisData()
        this.getUser();
        this.getServiceAreaList();

      },
      error => {
        sweetAlert('Error', error, 'error', 'OK');
      }
    );
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.timeZone = this.user.timeZone;
          this.todayDate = moment().tz(this.timeZone);

          this.newTripForm.patchValue({
            company: this.user._id,

            preScheduleTime: this.todayDate,
            scheduleTime: this.todayDate.toISOString(),

            preAppointmentTime: moment(this.todayDate).add(1, 'hours'),
            appointmentTime: moment(this.todayDate).add(1, 'hours').toISOString(),

            // preActualAppointmentTime: moment(this.todayDate).add(1, 'hours'),
            // actualAppointmentTime: moment(this.todayDate).add(1, 'hours').toISOString(),
          });
          if (this.scheduleTime) {
            this.newTripForm.patchValue({
              preScheduleTime: this.scheduleTime,
              scheduleTime: this.scheduleTime.toISOString(),
              preAppointmentTime: moment(this.scheduleTime).add(1, 'hours'),
              appointmentTime: moment(this.scheduleTime).add(1, 'hours').toISOString(),
            });
          }
          this.getDriverList();

          if (this.tripId) {
            this.getTripDetails();
          }

          if (this.trip) {
            this.setFormFromInputTrip(this.trip);
          }

          this.isAllowRates = checkRole(this.user);
        }
      });
  }

  getTripDetails() {
    this.assignTripService
      .getUnassignedTripDetailById(this.tripId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          // bypass normal trip to standingorder trip
          if (this.isStandingOrderClone) {
            data.jobStatus = "standing"
            data.status = "standing"
            data.isRecurring = true
            data.recurringEndDate = ''
            data.driver = null;
          }
          this.preparedDatePatch(data)
          setTimeout(() => {
            this.isEditDataLoaded = true;
          }, 3000);
        }
      }, err => {
        sweetAlert('Error', err, 'error', 'OK');
      });
  }


  getTripPurposeList() {
    this.tripPurposesService
      .getTripPurposesList('active')
      .subscribe(data => {
        if (data) {
          this.tripPurposeList = data;
        }
      });
  }

  getFundingSourceList() {
    this.corporateService
      .getCorporateUsers('active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.preCooperates = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          // this.fundingSourceList = data;
          this.fundingSourceList = data.filter(x => !x.isTripModificationNotAllowed);
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getModifierList() {
    this.modifierCodesService
      .getModifierCodes()
      .subscribe(data => {
        if (data) {
          this.modifierList = data;
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getLevelOfService() {

    return this.levelOfServiceService.getLevelOfServices({ status: 'active' });
  }

  getSpaceTypeList() {

    return this.levelOfServiceService.getSpaceTypes({ status: 'active' });
  }

  getPrimaryDiagnoseList() {
    this.primaryDiagnosisService
      .getPrimaryDiagnosis()
      .subscribe(data => {
        if (data) {
          this.primaryDiagnoseList = data;
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getAddonsList(fundingSourceId) {
    //add params to send the cooperate key in the equipment api
    let queryParams = {
      isAddon: true,
      cooperate: fundingSourceId
    }
    this.equipmentService
      .getEquipments(queryParams)
      .subscribe(data => {
        if (data) {
          this.addonsList = data;
          this.filteredAddonsList = data;
          this.onSelectSpaceType();

        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getDriverList() {
    this.driverService
      .getDrivers(this.user._id, 'active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.driverList = data;
        }
      });
  }

  get form() {
    return this.newTripForm.controls;
  }

  get legForm() {
    return this.newTripForm.get('tripLegs') as UntypedFormArray;
  }

  addLegItem() {
    const items = this.newTripForm.get('tripLegs') as UntypedFormArray;
    const preValues = this.newTripForm.value;
    let hour = (items.length * 2) + 1


    const FIELD_MAP = [
      { prev: 'jobDestinationAddress', new: 'jobOriginAddress' },
      { prev: 'jobDestinationLatitude', new: 'jobOriginLatitude' },
      { prev: 'jobDestinationLongitude', new: 'jobOriginLongitude' },
      { prev: 'zipCodeDest', new: 'zipCodeOrg' },
      { prev: 'serviceAreaDest', new: 'serviceArea' }
    ];

    const newLeg = this.fb.group({
      jobDestinationAddress: [preValues.jobOriginAddress, Validators.required],
      jobDestinationLatitude: [preValues.jobOriginLatitude, [Validators.required, nonZeroCoordinateValidator()]],
      jobDestinationLongitude: [preValues.jobOriginLongitude, [Validators.required, nonZeroCoordinateValidator()]],
      zipCodeDest: [preValues.zipCodeOrg],
      serviceAreaDest: [preValues.serviceArea],

      jobOriginAddress: [preValues.jobDestinationAddress, Validators.required],
      jobOriginLatitude: [preValues.jobDestinationLatitude, [Validators.required, nonZeroCoordinateValidator()]],
      jobOriginLongitude: [preValues.jobDestinationLongitude, [Validators.required, nonZeroCoordinateValidator()]],
      zipCodeOrg: [preValues.zipCodeDest],
      serviceArea: [preValues.serviceAreaDest],

      preScheduleTime: [moment(preValues.preAppointmentTime).add(hour, 'hours'), Validators.required],
      scheduleTime: [moment(preValues.preAppointmentTime).add(hour, 'hours').toISOString(), Validators.required],

      preAppointmentTime: [moment(preValues.preAppointmentTime).add(hour + 1, 'hours'), Validators.required],
      appointmentTime: [moment(preValues.preAppointmentTime).add(hour + 1, 'hours').toISOString(), Validators.required],

      companyNote: [''],
      isWillCall: [false],
      estimatedTime: [''],

      originAddressAdditional: this.fb.group({
        modifier: [preValues.destinationAddressAdditional.modifier],
        modifierTwo: [preValues.destinationAddressAdditional.modifierTwo],
        floor: [preValues.destinationAddressAdditional.floor],
        room: [preValues.destinationAddressAdditional.room],
        aptOrSuite: [preValues.destinationAddressAdditional.aptOrSuite],
        place: [preValues.destinationAddressAdditional.place],
        phone: [preValues.destinationAddressAdditional.phone]
      }),
      destinationAddressAdditional: this.fb.group({
        modifier: [preValues.originAddressAdditional.modifier],
        modifierTwo: [preValues.originAddressAdditional.modifierTwo],
        floor: [preValues.originAddressAdditional.floor],
        room: [preValues.originAddressAdditional.room],
        aptOrSuite: [preValues.originAddressAdditional.aptOrSuite],
        place: [preValues.originAddressAdditional.place],
        phone: [preValues.originAddressAdditional.phone]
      }),
    });

    items.push(newLeg);

    if (items.length > 1) {
      const prevLeg = items.at(items.length - 2) as UntypedFormGroup;
      const currentLeg = items.at(items.length - 1) as UntypedFormGroup;

      const createLink = (prevPath: string, newPath: string) => {
        prevLeg.get(prevPath).valueChanges.subscribe(value =>
          currentLeg.get(newPath).patchValue(value, { emitEvent: false })
        )
      };

      FIELD_MAP.forEach(({ prev, new: newPath }) => createLink(prev, newPath));

      (prevLeg.get('destinationAddressAdditional') as UntypedFormGroup).valueChanges.subscribe(value =>
        (currentLeg.get('originAddressAdditional') as UntypedFormGroup).patchValue(value, { emitEvent: false }));

      if (items.length > 1) {
        const resetValues = {
          jobDestinationAddress: null,
          jobDestinationLatitude: null,
          jobDestinationLongitude: null,
          zipCodeDest: null,
          serviceAreaDest: null,
          destinationAddressAdditional: {
            modifier: null,
            modifierTwo: null,
            floor: null,
            room: null,
            aptOrSuite: null,
            place: null,
            phone: null
          }
        };
        prevLeg.patchValue(resetValues);
      }
    }
  }

  removeLegItem(index: any) {
    const items = this.newTripForm.get('tripLegs') as UntypedFormArray;
    items.removeAt(index);
  }

  get addonsForm() {
    return this.newTripForm.get('addonServices') as UntypedFormArray;
  }

  addAddonsItem(preAddonList?) {
    const items = this.newTripForm.get('addonServices') as UntypedFormArray;

    if (preAddonList) {
      for (const addon of preAddonList) {
        items.push(
          this.fb.group({
            addonId: [addon.addonId, Validators.required],
            quantity: [addon.quantity, [Validators.required, Validators.min(1)]],
            title: [addon.title],
            fare: [addon.fare],
            code: [addon.code],
            total: [addon.total]
          })
        );

      }
      return;
    }

    // if (!items.invalid) {
    items.push(
      this.fb.group({
        addonId: ['', Validators.required],
        quantity: [1, [Validators.required, Validators.min(1)]],
        title: [''],
        fare: [0],
        code: [0],
        total: [0]
      })
    );
    // }
  }

  removeAddonsItem(index: any) {
    const items = this.newTripForm.get('addonServices') as UntypedFormArray;
    items.removeAt(index);
  }


  onSelectMember(member) {
    if (member) {
      this.newTripForm.patchValue({
        client: member._id,
        searchMember: member.displayName,
        isEligible:  member.isEligible,
        isNotEligible: member.isNotEligible
      });
      this.setMemberDetails(member);
      this.getMemberTrips(member);
    } else {
      this.newTripForm.patchValue({
        client: '',
      });
    }
  }

  setMemberDetails(member) {
    try {
      if (member) {
        console.log('member', member);
        let memberPayload: any = {
          searchMember: member.displayName,
          priorityClient: member,
          isVipTrip: member.type === "vip" ? true : false,
          preferredDriver: member.preferredDriver ? member.preferredDriver : null,
          originAddressAdditional: {
            phone: member.contactNumber,
            aptOrSuite: member.homeAddress.aptOrSuite,
          },
          dispatchNoteTwo: member.note + " ----------  " + member.privateNote,
        }

        if (member.homeAddress && member.homeAddress.address) {
          const myServiceArea = findServiceArea(member.homeAddress.zipCode, this.serviceAreaList);
          memberPayload = {
            ...memberPayload, jobOriginAddress: member.homeAddress.address,
            jobOriginLatitude: member.homeAddress.latitude,
            jobOriginLongitude: member.homeAddress.longitude,
            zipCodeOrg: member.homeAddress.zipCode,
            serviceArea: myServiceArea
          };
        }

        if (member.homeAddress && member.homeAddress.name) {
          memberPayload = {
            ...memberPayload,
            originAddressAdditional: {
              ...memberPayload.originAddressAdditional,
              place: member.homeAddress.name,
            }
          };
        }

        if (member.fundingSource) {
          memberPayload = { ...memberPayload, cooperate: member.fundingSource };
        }

        if (member.spaceType) {
          memberPayload = { ...memberPayload, spaceType: member.spaceType, los: member.los };
        }
        if (member.dob) {
          memberPayload = {
            ...memberPayload,
            priorityClient: {
              ...memberPayload.priorityClient,
              preDob: moment(member.dob).format('MM/DD/YYYY'),
              dob: member.dob
            }

          };

          console.log('memberPayload', memberPayload);
        }

        this.newTripForm.patchValue(memberPayload);

        //  if (member.spaceType) {
        //   this.newTripForm.patchValue({
        //     los: member.los,
        //     spaceType: member.spaceType
        //   });
        //   // this.onSelectLOS(member.los);
        // }

      } else {
        this.newTripForm.patchValue({
          searchMember: '',
          priorityClient: {
            displayName: '',
            contactNumber: '',
            cellPhone: '',
            clientId: '',
            email: '',
            dob: '',
            weight: '',
            gender: ''
          },
        });
      }
    } catch (err) {
      (err);
    }
  }

  setOriginAddress(place, index?) {
    const addressDetails = place ? getAddressDetails(place) : undefined;
    const zip = addressDetails.zipCode;
    const myServiceArea = findServiceArea(zip, this.serviceAreaList);

    if (index > -1) {
      const items = this.newTripForm.get('tripLegs') as UntypedFormArray;
      items.at(index).patchValue({
        jobOriginAddress: place.formatted_address,
        jobOriginLatitude: place.geometry.location.lat(),
        jobOriginLongitude: place.geometry.location.lng(),
        zipCodeOrg: zip,
        serviceArea: myServiceArea
      });
    } else {
      this.newTripForm.patchValue({
        jobOriginAddress: place.formatted_address,
        jobOriginLatitude: place.geometry.location.lat(),
        jobOriginLongitude: place.geometry.location.lng(),
        zipCodeOrg: zip,
        serviceArea: myServiceArea
      });
      this.calculateSuggestedPickupTime(); // calling order matters
    }
  }

  setDestinationAddress(place, index?) {
    const addressDetails = place ? getAddressDetails(place) : undefined;
    const zip = addressDetails.zipCode;
    const myServiceArea = findServiceArea(zip, this.serviceAreaList);
    if (index > -1) {
      const items = this.newTripForm.get('tripLegs') as UntypedFormArray;
      items.at(index).patchValue({
        jobDestinationAddress: place.formatted_address,
        jobDestinationLatitude: place.geometry.location.lat(),
        jobDestinationLongitude: place.geometry.location.lng(),
        zipCodeDest: zip,
        serviceAreaDest: myServiceArea
      });
    } else {
      this.newTripForm.patchValue({
        jobDestinationAddress: place.formatted_address,
        jobDestinationLatitude: place.geometry.location.lat(),
        jobDestinationLongitude: place.geometry.location.lng(),
        zipCodeDest: zip,
        serviceAreaDest: myServiceArea
      });
      this.calculateSuggestedPickupTime(); // calling order matters
    }
  }

  setPickTimeChange(event, index?) {
    if (index > -1) {
      const items = this.newTripForm.get('tripLegs') as UntypedFormArray;
      items.at(index).patchValue({
        scheduleTime: moment(event).tz(this.timeZone, true).toISOString(),
      });

      if (!this.tripId) {
        if (moment(event).tz(this.timeZone).format("HHmm") == '2359') {
          items.at(index).patchValue({
            preAppointmentTime: moment(event)
          });
        } else {
          items.at(index).patchValue({
            preAppointmentTime: moment(event).add(1, 'hours')
          });
        }
      }

    } else {
      this.newTripForm.patchValue({
        scheduleTime: moment(event).tz(this.timeZone, true).toISOString(),
      });

      if (!this.tripId) {
        this.newTripForm.patchValue({
          preAppointmentTime: moment(event).add(1, 'hours')
        });
        this.calculateEstAppointmentTime()
      }
    }
  }

  setDropOffTimeChange(event, index?) {
    if (index > -1) {
      const items = this.newTripForm.get('tripLegs') as UntypedFormArray;
      items.at(index).patchValue({
        appointmentTime: moment(event).tz(this.timeZone, true).toISOString(),
      });

    } else {
      this.newTripForm.patchValue({
        appointmentTime: moment(event).tz(this.timeZone, true).toISOString(),
      });
      this.calculateEstAppointmentTime();
    }
  }

  setActualAppointmentTimeChange(event) {
    this.newTripForm.patchValue({
      actualAppointmentTime: moment(event).tz(this.timeZone, true).toISOString(),
    });
    this.calculateSuggestedPickupTime(); // calling order matters
  }

  setWillCall(event, index) {
    const items = this.newTripForm.get('tripLegs') as UntypedFormArray;
    if (event.target.checked) {
      if (index == 0) {
        (this.legForm.at(index) as UntypedFormGroup).patchValue({
          estimatedTime: this.estAppointmentTime
        });
      }

      const time = items.at(index)['controls'].preScheduleTime.value;
      time.set('hour', 23)
      time.set('minute', 59)
      items.at(index)['controls'].preScheduleTime.setValue(time);

      items.at(index)['controls'].preScheduleTime.disable();
    } else {
      if (index == 0) {
        (this.legForm.at(index) as UntypedFormGroup).patchValue({
          estimatedTime: ''
        });
      }
      items.at(index)['controls'].preScheduleTime.enable();
    }

  }

  setWillCallInEdit(event) {
    if (event.target.checked) {
      const schTime = this.newTripForm['controls'].preScheduleTime.value;
      schTime.set('hour', 23)
      schTime.set('minute', 59)
      this.newTripForm['controls'].preScheduleTime.setValue(schTime);
      this.newTripForm['controls'].preScheduleTime.disable();

      const aptTime = this.newTripForm['controls'].preAppointmentTime.value;
      aptTime.set('hour', 23)
      aptTime.set('minute', 59)
      this.newTripForm['controls'].preAppointmentTime.setValue(aptTime);
      this.newTripForm['controls'].preAppointmentTime.disable();
    } else {
      this.newTripForm['controls'].preScheduleTime.enable();
      this.newTripForm['controls'].preAppointmentTime.enable();
    }
  }

  onSelectFundingSource(event) {
    this.newTripForm.patchValue({
      cooperateDetails: {
        displayName: '',
        profileImageURL: ''
      }
    });

    const fundingSource = this.fundingSourceList.find((fundingSource) => fundingSource._id === event);
    if (fundingSource) {
      this.newTripForm.patchValue({
        cooperateDetails: {
          displayName: fundingSource.displayName,
          profileImageURL: fundingSource.profileImageURL
        }
      });
      //Additional Code removed, clearing the array on change of funding source
      this.getAddonsList(fundingSource._id);
    }
    const addonServices = this.newTripForm.get('addonServices') as UntypedFormArray;
    // addonServices.clear();
  }

  // onSelectLOS(losId) {
  //   this.spaceTypeList = [];
  //   if (!losId) {
  //     this.newTripForm.patchValue({
  //       spaceType: ''
  //     });
  //     return;
  //   };

  //   this.spaceTypeList = this.spaceTypeMainList.filter(item => item.los === losId);
  //   const spaceTypes = this.spaceTypeList.filter(spaceTypeItem => spaceTypeItem._id === this.newTripForm.value.spaceType);
  //   if (!spaceTypes.length) {
  //     this.newTripForm.patchValue({
  //       spaceType: '',
  //     });
  //   }
  // }

  onSelectSpaceType() {
    this.newTripForm.patchValue({ los: '' });
    if (this.newTripForm.value.spaceType) {
      const selectedSpaceType = this.spaceTypeMainList.find(item => item._id === this.newTripForm.value.spaceType);
      if (selectedSpaceType && selectedSpaceType.los) {
        this.newTripForm.patchValue({
          los: selectedSpaceType.los,
        });
      }
    }
    const addonServices = this.newTripForm.get('addonServices') as UntypedFormArray;
    // addonServices.clear();
    this.filteredAddonsList = this.addonsList.filter(item => item.spaceType === this.newTripForm.value.spaceType)
  }


  onSelectAddonItem(addonItem) {
    if (!addonItem.value.addonId || !addonItem.value.quantity) return;

    const item = this.addonsList.find(item => item._id === addonItem.value.addonId);
    addonItem.patchValue({
      ...item,
      total: item.fare * addonItem.value.quantity
    });
  }

  async fileProcessing(ImageInput, form) {
    imageProcessing(ImageInput)
      .subscribe(async (result) => {
        const data: any = await this.proTipsService.changeCoverImage(result.file).toPromise();
        form.setValue(data.location);
      })
  }

  removeFile() {
    this.newTripForm.patchValue({ attachment: '' });
    this.fileInput.nativeElement.value = '';
  }


  get standingOrderForm() {
    return this.newTripForm.get('recurringDays') as UntypedFormArray;
  }

  addStandingDays(preStandingList?) {

    const recurringDaysItems = this.newTripForm.get('recurringDays') as UntypedFormArray;
    if (preStandingList) {

      for (let preItem of preStandingList) {
        const index = recurringDaysItems.controls.findIndex(item => item.value.day === preItem.day);
        if (index > -1) {
          recurringDaysItems.at(index).patchValue({
            checked: true,
            driver: preItem.driver ? preItem.driver : 'null'
          });

          recurringDaysItems.at(index)['controls'].driver.enable();
        }
      }
      return;
    }

    for (let dayItem of getstandingOrderDays) {
      recurringDaysItems.push(
        this.fb.group({
          label: [dayItem.label],
          day: [dayItem.day],
          checked: [false],
          driver: [{ value: 'null', disabled: true }],
        })
      );
    }
  }

  onChangeStandingDay(event, form) {
    if (event) {
      form.controls.driver.enable();
    } else {
      form.controls.driver.disable();
    }
  }

  onChangeStandingStatus(event) {
    const isEnabled = JSON.parse(event.target.value);
    if (this.tripId && !isEnabled) {
      sweetAlert('Alert', 'Are you sure you want to inactive standing orders? This action will reset the recurring date to today and remove all the future existing trips.', 'warning', 'Yes', 'No')
        .then((result: any) => {
          if (result.value) {
            const standingOrderDate = moment().tz(this.timeZone, true).startOf('day');
            if (this.newTripForm.value.recurringEndDate) {
              const previousDate = moment(this.newTripForm.value.recurringEndDate).tz(this.timeZone, true).startOf('day');
              if (previousDate.isAfter(standingOrderDate)) {
                this.newTripForm.patchValue({
                  preRecurringEndDate: standingOrderDate,
                  recurringEndDate: standingOrderDate.toISOString(),
                  isRecurring: isEnabled
                });
              } else {
                this.newTripForm.patchValue({
                  isRecurring: isEnabled
                });
              }
            } else {
              this.newTripForm.patchValue({
                preRecurringEndDate: standingOrderDate,
                recurringEndDate: standingOrderDate.toISOString(),
                isRecurring: isEnabled
              });
            }
          } else {
            this.newTripForm.patchValue({
              isRecurring: true
            });
          }
        });
    } else {
      this.newTripForm.patchValue({
        isRecurring: isEnabled
      });
    }
  }

  setStandingDateChange(event) {
    if (event) {
      this.newTripForm.patchValue({
        recurringEndDate: moment(event).tz(this.timeZone, true).startOf('day').toISOString()
      });
    }
  }

  async onCreateTrip() {
    this.validateDOB();
    if (this.tripId) {
      const rest = await this.inProgressTripCheck();
      if (rest && rest.status === 'inprogress') {
        sweetAlert('Alert', 'Inprogress trip cannot be edited', 'warning', 'Okay')
        return;
      }
    }
    this.submitted = true;
    if (this.newTripForm.invalid) return;

    if (!this.newTripForm.value.priorityClient.contactNumber) {
      this.newTripForm.controls.priorityClient.patchValue({
        contactNumber: '0000000000'
      })
    }

    let payload = this.newTripForm.value;
    payload = {
      ...payload,
      attendees: this.selectedAssist && this.selectedAssist.length ? this.selectedAssist : null
    };
    // checking standing orders
    if (payload.isRecurring) {
      let recurringDays = [];
      for (let standingOrderDay of payload.recurringDays) {
        if (standingOrderDay.checked) {
          recurringDays.push({ ...standingOrderDay, driver: standingOrderDay.driver === 'null' ? null : standingOrderDay.driver })
        }
      }

      if (recurringDays.length) {
        payload.recurringDays = recurringDays;
        payload.status = 'standing';
        payload.jobStatus = 'standing';
      }
      if (!payload.milage)
        delete payload.milage
    } else {
      delete payload.recurringDays
      if (!payload.status || !payload.jobStatus) {
        delete payload.status
        delete payload.jobStatus
      }
    }

    if (!payload.originAddressAdditional.modifier) {
      payload.originAddressAdditional.modifier = null
    }

    if (!payload.destinationAddressAdditional.modifier) {
      payload.destinationAddressAdditional.modifier = null
    }
    if (!payload.serviceArea) {
      payload.serviceArea = null;
    }
    if (!payload.serviceAreaDest) {
      payload.serviceAreaDest = null;
    }

    for (let leg of payload.tripLegs) {
      if (!leg.originAddressAdditional.modifier) {
        leg.originAddressAdditional.modifier = null
      }

      if (!leg.destinationAddressAdditional.modifier) {
        leg.destinationAddressAdditional.modifier = null
      }
      if (!leg.serviceArea) {
        leg.serviceArea = null
      }
      if (!leg.serviceAreaDest) {
        leg.serviceAreaDest = null
      }
    }

    this.assignTripService
      .createNewTripV2(payload, this.isStandingOrderClone ? null : this.tripId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          if (this.editId || this.scheduleTime) {
            this.onUpdate.emit(data);
          } else {
            this.onCreate.emit(data);
            this.router.navigateByUrl('trips');
          }
        }
      }, err => {
        sweetAlert('Error', err, 'error', 'OK');
      });

  }

  async inProgressTripCheck() {
    const res: any = await this.assignTripService
      .getUnassignedTripDetailById(this.tripId)
      .toPromise();
    return res;
  }

  openAddMemberModal(member) {
    this.addMemberModalObj = member;
  }

  onSaveMember(evt) {
    if (evt) {
      // Update the form with new member details
      this.newTripForm.patchValue({
        client: evt._id
      });

      this.setMemberDetails(evt);
      this.addMemberModalObj = null;
    }
  }





  getServiceAreaList() {
    this.serviceArea
      .getServiceAreas({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.serviceAreaList = data;
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  calculateEstimatedFare() {
    const { jobOriginLatitude, jobOriginLongitude, jobDestinationLatitude, jobDestinationLongitude, scheduleTime, cooperate, spaceType, milage, addonServices } = this.newTripForm.value;

    if (!jobOriginLatitude || !jobOriginLongitude || !jobDestinationLatitude || !jobDestinationLongitude || !scheduleTime || !cooperate || !spaceType) {
      sweetAlert('Alert', 'Please select Pickup, Drop Off address, Space Type, Pickup Time & Funding Source', 'warning', 'Ok')
      return;
    }

    let payload;

    payload = {
      company: this.user._id,
      jobDestinationLatitude: jobDestinationLatitude,
      jobDestinationLongitude: jobDestinationLongitude,
      jobOriginLatitude: jobOriginLatitude,
      jobOriginLongitude: jobOriginLongitude,
      spaceType: spaceType,
      cooperate: cooperate,
      scheduleTime: scheduleTime
    };

    if (milage) {
      payload.milage = milage;
    }

    if (addonServices && addonServices.length) {
      payload = { ...payload, addonServices: addonServices }
    }

    this.assignTripService
      .calculateEstimateFare(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.newTripForm.patchValue({
            estimateFare: data.totalFare
          })
        }
      });
  }

  loadAddressPicker(title, value, address?, lat?, lng?, zipCode?) {
    this.addressPickerObj = { title, value, address, lat, lng, zipCode };
  }

  onAddressPicker(event) {
    this.addressPickerObj = null;
    const items = this.newTripForm.get('tripLegs') as UntypedFormArray;
    if (!event) return;

    // For Pickup Addresss
    if (event.reference.value === '0') {
      this.newTripForm.patchValue({
        jobOriginAddress: event.address,
        jobOriginLatitude: event.lat,
        jobOriginLongitude: event.lng,
        zipCodeOrg: event.zipCode
      });
      this.calculateSuggestedPickupTime(); // calling order matters
    } else if (event.reference.value === '1') {
      this.newTripForm.patchValue({
        jobDestinationAddress: event.address,
        jobDestinationLatitude: event.lat,
        jobDestinationLongitude: event.lng,
        zipCodeDest: event.zipCode
      });
      this.calculateSuggestedPickupTime(); // calling order matters
    } else if (event.reference.value === '01') {
      items.at(0).patchValue({
        jobOriginAddress: event.address,
        jobOriginLatitude: event.lat,
        jobOriginLongitude: event.lng,
        zipCodeOrg: event.zipCode
      });
    } else if (event.reference.value === '11') {
      items.at(0).patchValue({
        jobDestinationAddress: event.address,
        jobDestinationLatitude: event.lat,
        jobDestinationLongitude: event.lng,
        zipCodeDest: event.zipCode
      });
    } else if (event.reference.value === '02') {
      items.at(1).patchValue({
        jobOriginAddress: event.address,
        jobOriginLatitude: event.lat,
        jobOriginLongitude: event.lng,
        zipCodeOrg: event.zipCode
      });
    } else if (event.reference.value === '12') {
      items.at(1).patchValue({
        jobDestinationAddress: event.address,
        jobDestinationLatitude: event.lat,
        jobDestinationLongitude: event.lng,
        zipCodeDest: event.zipCode
      });
    }

    if (this.newTripForm.value.jobOriginAddress &&
      this.newTripForm.value.jobOriginLatitude &&
      this.newTripForm.value.jobOriginLongitude &&
      this.newTripForm.value.jobDestinationAddress &&
      this.newTripForm.value.jobDestinationLatitude &&
      this.newTripForm.value.jobDestinationLongitude) {
    }
  }

  onDateChange(evt, control: AbstractControl) {
    if (evt) {
      control.setValue(moment(evt).toISOString());
    }
  }

  dobValidator(control: AbstractControl) {
    const dateValue = control.value;
    if (!dateValue) return null;

    const isValidFormat = moment(dateValue, 'MM/DD/YYYY', true).isValid();
    return isValidFormat ? null : { invalidDateFormat: true };
  }

  validateDOB() {
    const control = this.newTripForm.controls.priorityClient.get('preDob');
    if (control && control.valid) {
      const dateValue = moment(control.value, 'MM/DD/YYYY').toISOString();
      this.newTripForm.controls.priorityClient.patchValue({ dob: dateValue }, { emitEvent: false });
    }
  }

  getAssisData() {
    this.assistService.getAssistList()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.assistList = data;
        }
      });
  }

  getMiles() {
    if (!this.newTripForm.value.jobOriginAddress || !this.newTripForm.value.jobDestinationAddress) {
      sweetAlert('Alert', 'Please select Pickup & Drop Off address', 'warning', 'OK')
      return;
    }

    this.setUpSocketListener();
    let data = {
      origin: this.newTripForm.value.jobOriginLatitude + ',' + this.newTripForm.value.jobOriginLongitude,
      destination: this.newTripForm.value.jobDestinationLatitude + ',' + this.newTripForm.value.jobDestinationLongitude
    };
    this.socketService.emit(Events.GET_MILES_CALL, data);
  }

  setUpSocketListener() {
    this.socketService.addListener(Events.GET_MILES_CALL)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        this.googleMilage = data.message;
        this.socketService.removeListener(Events.GET_MILES_CALL);
        setTimeout(() => {
          this.googleMilage = '';
        }, 5000);
      });
  }

  getMemberTrips(member) {
    this.assignedTrips = [];
    const payload = {
      // displayName: name
      client: member._id,
    };
    this.assignTripService
      .getMemberTrips(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.assignedTrips = data;
        }
      });
  }

  ngOnDestroy(): void {
  }

  preparedDatePatch(data: any) {
    const preData = JSON.parse(JSON.stringify(data));
    // remove standing order
    delete preData.recurringDays;
    delete preData.addonServices;

    this.newTripForm.patchValue({
      ...preData,
      preferredDriver : preData.preferredDriver ? preData.preferredDriver : null,
      searchMember: preData.priorityClient.displayName,
      preScheduleTime: moment(preData.scheduleTime).tz(this.timeZone),
      preAppointmentTime: moment(preData.appointmentTime).tz(this.timeZone),
      // preActualAppointmentTime: moment(preData.actualAppointmentTime).tz(this.timeZone),
      preRecurringEndDate: preData.recurringEndDate ? moment(preData.recurringEndDate).tz(this.timeZone) : null,
      priorityClient: {
        ...preData.priorityClient,
        preDob: preData.priorityClient && preData.priorityClient.dob ? moment(preData.priorityClient.dob).tz(this.timeZone).format('MM/DD/YYYY') : '',
      }
    });
    // this.onSelectLOS(data.los);

    if (data.cooperate) {
      this.getAddonsList(data.cooperate);
    }

    if (data.addonServices) {
      this.addAddonsItem(data.addonServices)
    }

    if (data.status === "standing") {
      this.addStandingDays(data.recurringDays);
    }

    this.selectedAssist = data.attendees;
  }

  onSelectHistoryTrip(data) {
    this.preparedDatePatch(data);
  }

  onAppointmentChange(selectedItems) {
    const selectedIds = selectedItems.map(item => item._id);
    this.calculateEstAppointmentTime(selectedIds);
  }

  calculateEstAppointmentTime(appointments?) {
    const preAppointmentTime = this.newTripForm.get('preAppointmentTime').value;
    let totalAppointmentTime = 0;
    if (appointments && appointments.length) {
      let selectedItems = [];
      selectedItems = this.tripPurposeList.filter(item =>
        appointments.includes(item._id)
      );
      totalAppointmentTime = selectedItems.reduce(
        (acc, curr) => acc + (curr.time || 0),
        0
      );
    }

    this.estAppointmentTime = null;
    this.estAppointmentTime = moment(preAppointmentTime)
      .tz(this.timeZone)
      .add(totalAppointmentTime || 60, 'minutes');

  }

  async calculateSuggestedPickupTime() {
    return;
    if (this.tripId && !this.isEditDataLoaded) return; // prevent calculation on edit trip form load
    this.suggestedPickupTime = null;
    const {
      jobOriginAddress,
      jobOriginLatitude,
      jobOriginLongitude,
      jobDestinationAddress,
      jobDestinationLatitude,
      jobDestinationLongitude,
      actualAppointmentTime
    } = this.newTripForm.value;

    // stop if any of the following doesn't have a value
    if (!(jobOriginAddress && jobDestinationAddress && actualAppointmentTime)) return;

    this.isCalculating = true;
    const queryParams = {
      start: [jobOriginLongitude, jobOriginLatitude].toString(),
      end: [jobDestinationLongitude, jobDestinationLatitude].toString(),
    };

    try {
      const minutes = await this.calculateTime(queryParams);
      const estimatedPickupTime = moment(actualAppointmentTime).tz(this.timeZone).subtract(minutes, 'minutes');
      this.suggestedPickupTime = estimatedPickupTime;

      const newScheduleTime = estimatedPickupTime.subtract(20, 'minutes');

      this.newTripForm.patchValue({
        preScheduleTime: newScheduleTime,
        scheduleTime: newScheduleTime.toISOString(),

        preAppointmentTime: newScheduleTime.clone().add(minutes, 'minutes'),
        appointmentTime: newScheduleTime.clone().add(minutes, 'minutes').toISOString(),
      });
      this.isCalculating = false;
    } catch (error) {
      this.isCalculating = false;
    }
  }

  async calculateTime(queryParams) {
    const res: any = await this.assignTripService.calculateMiles(queryParams).pipe(takeUntil(componentDestroyed(this))).toPromise();
    let duration = 60;
    if (
      res &&
      res.features &&
      res.features[0] &&
      res.features[0].properties &&
      res.features[0].properties.segments &&
      res.features[0].properties.segments[0] &&
      res.features[0].properties.segments[0].duration
    ) {
      console.log("calculateMiles: ", res.features[0].properties.segments[0])
      duration = res.features[0].properties.segments[0].duration / 60;
    }

    return duration;
  }

  toggleBiWeeklySO() {
    this.newTripForm.patchValue({
      isBiWeekly: !this.newTripForm.value.isBiWeekly
    });
  }

}

